import { createAction } from '@reduxjs/toolkit';

export const TOGGLE_LAYOUT = createAction('TOGGLE_LAYOUT');
